import request from '@/utils/request'

// 获取oss token
export function getOssToken() {
    return request({
        url: '/console/services/oss-security-token',
        method: 'GET'
    })
}
